// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"f249f0dc","346":"a129d8b7","390":"cbc17df9","453":"83dec03a"}[chunkId] + ".chunk.js";
};